import { render, staticRenderFns } from "./projectsFilesTabNew.vue?vue&type=template&id=ee31ae2a&scoped=true&"
import script from "./projectsFilesTabNew.vue?vue&type=script&lang=js&"
export * from "./projectsFilesTabNew.vue?vue&type=script&lang=js&"
import style0 from "./projectsFilesTabNew.vue?vue&type=style&index=0&id=ee31ae2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee31ae2a",
  null
  
)

export default component.exports